namespace GeniuzPOS.Purchase {
    export interface ListLastAppPurOrderRow {
        SysDocNo?: string;
        ApproveBy?: string;
        DisplayName?: string;
        AppDate?: string;
    }

    export namespace ListLastAppPurOrderRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.ListLastAppPurOrder';
        export const lookupKey = 'Purchase.ListLastAppPurOrder';

        export function getLookup(): Q.Lookup<ListLastAppPurOrderRow> {
            return Q.getLookup<ListLastAppPurOrderRow>('Purchase.ListLastAppPurOrder');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            ApproveBy = "ApproveBy",
            DisplayName = "DisplayName",
            AppDate = "AppDate"
        }
    }
}
